export default ({...props}) => {
  const {space, size} = props.theme
  return `
    max-width: ${size(43.375)}px;
    margin: auto;
    text-align: center;
    padding-top: ${size(1)}px;
    & > div:first-child {
      margin-bottom: ${space(2.5)}px;
      [ap_atom_name="stackAtom"]{
        & > * {
          padding: 0px;
        }
      }
    }
    fieldset {
      margin-bottom: ${space(3)}px;
    }
  `
}
